const StarRibbon = ({id = 'star-ribbon'}) => (
    <svg aria-hidden width="173" height="195" viewBox="0 0 173 195" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 1171277184">
            <g id="Group 1171277181">
                <g id="Group 1171277180">
                    <g id="Star 20" filter={`url(#filter0_d_2465_619_${id})`}>
                        <path
                            d="M91.5306 33.4914C92.725 32.1366 94.837 32.1366 96.0314 33.4914L99.5959 37.5349C100.57 38.6394 102.201 38.874 103.446 38.0888L107.999 35.2184C109.526 34.2555 111.552 34.85 112.317 36.4857L114.605 41.3809C115.228 42.7138 116.726 43.3981 118.141 42.9967L123.319 41.5285C125.054 41.0363 126.829 42.1761 127.102 43.9591L127.925 49.3143C128.148 50.7668 129.391 51.8438 130.86 51.8587L136.249 51.9133C138.051 51.9315 139.43 53.5227 139.192 55.3088L138.476 60.69C138.283 62.1447 139.17 63.5259 140.573 63.9548L145.739 65.5335C147.461 66.0595 148.335 67.9724 147.605 69.618L145.405 74.5844C144.811 75.9247 145.272 77.498 146.496 78.3047L151.019 81.2855C152.521 82.2754 152.82 84.3553 151.658 85.7284L148.152 89.8715C147.205 90.9901 147.205 92.629 148.152 93.7476L151.658 97.8907C152.82 99.2638 152.521 101.344 151.019 102.334L146.496 105.314C145.272 106.121 144.811 107.694 145.405 109.035L147.605 114.001C148.335 115.647 147.461 117.56 145.739 118.086L140.573 119.664C139.17 120.093 138.283 121.474 138.476 122.929L139.192 128.31C139.43 130.096 138.051 131.688 136.249 131.706L130.86 131.76C129.391 131.775 128.148 132.852 127.925 134.305L127.102 139.66C126.829 141.443 125.054 142.583 123.319 142.091L118.141 140.622C116.726 140.221 115.228 140.905 114.605 142.238L112.317 147.133C111.552 148.769 109.526 149.364 107.999 148.401L103.446 145.53C102.201 144.745 100.57 144.98 99.5959 146.084L96.0314 150.128C94.837 151.482 92.725 151.482 91.5306 150.128L87.966 146.084C86.9924 144.98 85.3611 144.745 84.1157 145.53L79.5628 148.401C78.0355 149.364 76.0098 148.769 75.2452 147.133L72.9568 142.238C72.3337 140.905 70.8361 140.221 69.4206 140.622L64.2431 142.091C62.5076 142.583 60.7334 141.443 60.4594 139.66L59.6368 134.305C59.4137 132.852 58.1713 131.775 56.702 131.76L51.3132 131.706C49.5114 131.688 48.1321 130.096 48.3698 128.31L49.0858 122.929C49.2794 121.474 48.3922 120.093 46.9888 119.664L41.8226 118.086C40.1012 117.56 39.2274 115.647 39.9566 114.001L42.1574 109.035C42.7513 107.694 42.2896 106.121 41.0656 105.314L36.5431 102.334C35.0412 101.344 34.742 99.2638 35.9041 97.8907L39.4104 93.7476C40.3571 92.629 40.3571 90.9901 39.4104 89.8715L35.9041 85.7284C34.742 84.3553 35.0412 82.2754 36.5431 81.2855L41.0656 78.3047C42.2896 77.498 42.7513 75.9247 42.1574 74.5844L39.9566 69.618C39.2274 67.9724 40.1013 66.0595 41.8226 65.5335L46.9888 63.9548C48.3922 63.5259 49.2794 62.1447 49.0858 60.69L48.3698 55.3088C48.1321 53.5227 49.5114 51.9315 51.3132 51.9133L56.702 51.8587C58.1713 51.8438 59.4137 50.7668 59.6368 49.3143L60.4594 43.9591C60.7334 42.1761 62.5076 41.0363 64.2431 41.5285L69.4206 42.9967C70.8361 43.3981 72.3337 42.7138 72.9568 41.3809L75.2452 36.4857C76.0098 34.85 78.0355 34.2555 79.5628 35.2184L84.1157 38.0888C85.3611 38.874 86.9924 38.6394 87.966 37.5349L91.5306 33.4914Z"
                            fill={`url(#paint0_linear_2465_619_${id})`}
                        />
                    </g>
                </g>
                <path
                    id="Star 34"
                    d="M7.77254 1.32642L8.3036 4.91628L11.7251 6.12554L8.47508 7.73995L8.38231 11.3677L5.8426 8.77559L2.36374 9.8084L4.04417 6.59198L1.98688 3.60255L5.56515 4.2068L7.77254 1.32642Z"
                    fill="white"
                />
                <path
                    id="Star 35"
                    d="M158.086 182.681L157.64 186.282L160.615 188.361L157.052 189.049L155.994 192.521L154.238 189.345L150.61 189.412L153.088 186.761L151.903 183.331L155.19 184.868L158.086 182.681Z"
                    fill="white"
                />
                <path
                    id="Star 36"
                    d="M74.8649 117.692L76.0684 119.317L78.0677 119.013L76.894 120.66L77.8007 122.468L75.8718 121.86L74.4329 123.281L74.4145 121.259L72.6184 120.33L74.536 119.687L74.8649 117.692Z"
                    fill="white"
                />
                <path
                    id="Star 37"
                    d="M45.4563 37.4895L45.7354 39.9146L48.0095 40.8019L45.7893 41.8167L45.6482 44.2537L43.997 42.4559L41.6356 43.0747L42.8353 40.9487L41.517 38.8942L43.9096 39.3781L45.4563 37.4895Z"
                    fill="white"
                />
                <path
                    id="Star 38"
                    d="M118.379 52.9207L118.61 54.9298L120.494 55.6649L118.654 56.5056L118.538 58.5246L117.17 57.0351L115.213 57.5478L116.207 55.7865L115.115 54.0844L117.097 54.4854L118.379 52.9207Z"
                    fill="white"
                />
                <path
                    id="Star 39"
                    d="M132.374 156.851L132.838 159.248L135.173 159.959L133.037 161.14L133.082 163.581L131.298 161.914L128.991 162.712L130.025 160.5L128.554 158.552L130.976 158.852L132.374 156.851Z"
                    fill="white"
                />
                <path
                    id="Star 40"
                    d="M116.351 22.3901L116.814 24.7868L119.149 25.498L117.013 26.6793L117.058 29.1199L115.275 27.4532L112.967 28.2504L114.001 26.0391L112.53 24.0911L114.953 24.3911L116.351 22.3901Z"
                    fill="white"
                />
                <path
                    id="Star 41"
                    d="M97.6986 163.092L98.1619 165.489L100.497 166.2L98.3608 167.382L98.4059 169.822L96.6224 168.156L94.3151 168.953L95.3491 166.741L93.878 164.794L96.3005 165.094L97.6986 163.092Z"
                    fill="white"
                />
                <path
                    id="Star 42"
                    d="M165.852 112.208L167.81 115.992L172.07 116.03L169.077 119.061L170.357 123.125L166.549 121.215L163.081 123.688L163.72 119.476L160.296 116.941L164.499 116.248L165.852 112.208Z"
                    fill="white"
                />
                <path
                    id="Star 43"
                    d="M82.0646 4.74933L81.8161 9.00213L85.459 11.2105L81.3376 12.2883L80.363 16.4354L78.0644 12.8487L73.8191 13.2034L76.5199 9.90888L74.8708 5.98098L78.8386 7.53156L82.0646 4.74933Z"
                    fill="white"
                />
                <circle id="Ellipse 473" cx="14.5" cy="26.5" r="1.5" fill="white" />
                <circle id="Ellipse 474" cx="103.5" cy="135.5" r="1.5" fill="white" />
                <circle id="Ellipse 475" cx="157" cy="42" r="2" fill="white" />
                <circle id="Ellipse 476" cx="95" cy="60" r="2" fill="white" />
                <path
                    id="Vector 301"
                    d="M142.1 9.48691C142.348 10.1485 142.407 11.5985 140.658 12.1058C137.975 12.8841 138.747 14.466 138.885 15.329"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    id="Vector 302"
                    d="M39.9162 19.6417C40.3553 19.3736 41.384 19.1329 41.9858 20.3141C42.9092 22.1263 43.9347 21.358 44.533 21.1417"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    id="Vector 303"
                    d="M154.774 150.98C154.268 151.474 152.965 152.112 151.796 150.716C150.003 148.573 148.866 149.917 148.131 150.391"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </g>
        </g>
        <defs>
            <filter
                id={`filter0_d_2465_619_${id}`}
                x="35.1938"
                y="32.4753"
                width="117.174"
                height="123.668"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2465_619" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2465_619" result="shape" />
            </filter>
            <linearGradient
                id={`paint0_linear_2465_619_${id}`}
                x1="93.781"
                y1="81.0676"
                x2="93.781"
                y2="152.68"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FDB32C" />
                <stop offset="1" stopColor="#EA8B0D" />
            </linearGradient>
        </defs>
    </svg>
)

export default StarRibbon
